import label from "@/lang/StaticLabels.js";

// PORDR Navbar  - سفارشات -----------------------------------------------
let navItems = [
  {
    title: label.modules.pordr,
    icon: "mdi-clipboard-list-outline",
    to: false,
  },
  {
    to: "PORDRDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PORDRBlackList",
        label: label.menu.blackList,
        metaLabel: label.page.blackList,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PORDRSaleManagerDiscountLimit",
        label: label.menu.saleManagerDiscountLimit,
        metaLabel: label.page.saleManagerDiscountLimit,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PORDRSaleManagerCredit",
        label: label.menu.saleManagerCredit,
        metaLabel: label.page.saleManagerCredit,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PORDRSettlementType",
        label: label.menu.settlementType,
        metaLabel: label.page.settlementType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PORDRSetting",
        label: label.menu.settings,
        metaLabel: label.page.orderSetting,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.saleOrder,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PORDROrderAdd",
            label: label.menu.addSaleOrder,
            metaLabel: label.page.addSaleOrder,
            icon: "mdi-circle-small",
          },
          {
            to: "PORDROrderList",
            label: label.menu.saleOrderList,
            metaLabel: label.page.saleOrder,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: "PORDROrderCartable",
        label: label.menu.saleOrderCartable,
        metaLabel: label.page.saleOrderCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PORDROrderManagementCartable",
        label: label.menu.saleOrderManagementCartable,
        metaLabel: label.page.saleOrderManagementCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
